import React, { useEffect, useState } from "react";
// import ListingCard from "./ListingCard";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
// import "./listingCard.css"
import { useSearchParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import { checkReplaceUrl } from "../../utils";

export const ResearchListing = ({ searchResults, onPageChange, listingHeader,totalResource }) => {
  const { t } = useTranslation();

  const [searchData, setSearchData] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const url = window.location.href;
  const slug = url.split('?')[0].split('/').pop();
  const [searchParams, setSearchParams] = useSearchParams();

  const sliceName = slug === "search" ? "searchLanding" : slug.includes("search-support") ? "supportSearch" : "";
//   const isLoading = useSelector((state) => state[sliceName]?.search?.isLoading);
  const isLoading = useSelector((state) => state?.resourceLibrary?.loading);


useEffect(()=>{
	const page = searchParams.get('p') ? searchParams.get('p') : 1;
    setCurrentPage(page);
	if(searchResults.length>0){
		setTotalResults(totalResource)
		setTotalPages(Math.ceil(totalResource / 9));
		const newPages = [];
		for (let i = 1; i <= totalResource; i++) {
		  newPages.push(
			<li key={i}>
			  <button
				className={`sd-py-1 sd-px-2 ${currentPage == i ? 'sd-bg-black sd-text-white' : 'sd-text-black'} sd-rounded-sm hover:sd-bg-black hover:sd-text-white ${totalPages === 1 ? 'sd-mx-5' : ''}`}
				key={i}
				onClick={() => handlePageClick(i)}
			  >
				{i}
			  </button>
			</li>
		  );
		}
		setPages(newPages);
		setSearchData(searchResults);
	}
	else{
		setSearchData([])
	}
	
	console.log(searchResults,'searchResults')
},[searchResults])


  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
      setCurrentPage(currentPage - 1);
      handlePageClick(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
      setCurrentPage(currentPage + 1);
      handlePageClick(currentPage + 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    //move focus to div id searchResultContainer
    const searchResultContainer = document.getElementById("searchResultContainer");
    if (searchResultContainer) {
      searchResultContainer.scrollIntoView({ behavior: "smooth" });
    }

    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  const convertDate =(dateString)=> {
	const date = new Date(dateString); // Parse the date string
	const options = { year: 'numeric', month: 'short', day: 'numeric' }; // Formatting options
	return date.toLocaleDateString('en-US', options); // Convert to desired format
  }

  return (
    <React.Fragment>
      {
        <div
          className="sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 lg:sd-pl-0"
          id="searchResultContainer"
        >
          <div className="col-sm-12">
            <div className="search-results-container">
              {searchResults && searchResults?.length > 0 && (
                <h2 className="sd-uppercase sd-text-[13px] sd-titleText sd-mb-12">
                  {listingHeader
                    ? `${listingHeader} `
                    : `${t("searchResult")} `}{" "}
                  {totalResults ? `[${totalResults}]` : ""}
                </h2>
              )}
			  {isLoading &&
			  <h2 className="sd-uppercase sd-text-[13px]  lg:sd-my-[52px] sd-my-[88px]">
			  <div className="sd-bg-[#E9E9E9] sd-h-6 sd-w-1/6 sd-mb-2 sd-rounded sd-animate-pulse"></div>
				</h2>
			  }
              <ul
                id="searchResultContainerDiv"
                className="search-results sd-list-group sd-pl-0"
              >
                {isLoading ? (
                  <>
                    {Array(5)
                      .fill(0)
                      .map((_, index) => (
                        <li
                          key={index}
                          className="sd-cols-span-14 sm:sd-cols-span-10 sm:sd-offs-1  sd-list-reset"
                        >
                          <div
                            id="skeleton-loader"
                            className="sd-bg-[#f7f7f7]  sd-h-28 sd-mb-4 sd-p-4 sd-animate-pulse"
                          ></div>
                        </li>
                      ))}
                
                  </>
                ) : searchData?.length > 0 ? (
                  searchData.map((item, index) => (
                    // <ListingCard data={docs} key={index + "sd-card"} />
                    <li className="sd-cols-span-14 sm:sd-cols-span-10 sm:sd-offs-1  sd-list-reset">
                      <div
                        id="text-10ef7ea622"
                        class="cmp-text sd-bg-[#E9E9E9] sd-mb-4 sd-p-4"
                      >
                        <div className="sd-text-[12px] sd-font-nb sd-mb-2">
                          {convertDate(item.documentTypeDate)}
                        </div>
                        <a
                          className="sd-cursor-pointer sd-underline hover:sd-no-underline"
                          href={checkReplaceUrl(item.url)}
                          target="_blank"
                        >
                          <h3 class="sd-titleText sd-my-4 sd-text-[13px] sd-leading-[120%]">
                            {item.title[0]}
                          </h3>
                        </a>
                        <a
                          className="sd-cursor-pointer sd-underline hover:sd-no-underline"
                          href={checkReplaceUrl(item.url)}
                          target="_blank"
                        >
                          <p class="sd-flex sd-text-sm">
                            <MdDownload className="sd-my-1 sd-mr-2" />
                            Download
                          </p>
                        </a>
                      </div>
                    </li>
                  ))
                ) : (
                  ""
                )}
              </ul>
              {searchData?.length > 2 && (
                <div className="sd-pagination-container sd-flex sd-items-baseline sd-justify-center sd-mb-10">
                  <button
                    disabled={currentPage === 1 ? true : false}
                    className={`sd-py-1 sd-px-2 ${
                      currentPage === 1
                        ? "sd-pointer-events-none sd-text-gray-300"
                        : "sd-text-gray-600"
                    }  sd-rounded-sm active:sd-bg-black active:sd-text-white`}
                    onClick={handlePrev}
                  >
                    {t("previous")}
                  </button>
                  <ul className="sd-flex sd-space-x-3 sd-items-center">
                    {pages.length > 5 ? (
                      <React.Fragment>
                        {pages.slice(0, 5)}
                        <li>
                          <button
                            className="sd-py-2 sd-px-2 sd-text-gray-300 sd-rounded-sm hover:sd-bg-black hover:sd-text-white"
                            onClick={() => {
                              setPages(pages.slice(5));
                            }}
                          >
                            ...
                          </button>
                        </li>
                      </React.Fragment>
                    ) : (
                      pages
                    )}
                  </ul>
                  <button
                    disabled={currentPage === totalPages ? true : false}
                    className={`sd-py-1 sd-px-2 ${
                      currentPage === totalPages
                        ? "sd-pointer-events-none sd-text-gray-300"
                        : ""
                    }  sd-text-black sd-rounded-sm hover:sd-bg-black hover:sd-text-white`}
                    onClick={handleNext}
                  >
                    {t("next")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  );
};

export default ResearchListing;

